import './styles.scss'

import '~/assets/stylesheets/site/grid.scss'

import React from 'react'
import { useValues, useMountedLogic } from 'kea'

import { hot } from 'react-hot-loader'
import Helmet from 'lib/tags/helmet'

import { useUpdateDimensions } from 'lib/plugins/dimensions'

import FiltersPage from '~/scenes/search/filters-page'
import SearchPage from '~/scenes/search/search-page'

import sceneLogic from './logic'
import sceneSaga from './saga'

function Search () {
  useMountedLogic(sceneSaga)
  useUpdateDimensions(sceneLogic)

  const {
    isFullScreenFiltersPage,
    results: { helmet }
  } = useValues(sceneLogic)

  return (
    <>
      <Helmet helmet={helmet} />
      {isFullScreenFiltersPage ? <FiltersPage /> : <SearchPage />}
    </>
  )
}
export default hot(module)(Search)
